import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "document-list-header__header-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, { class: "document-list-header__header" }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "document-list-header__title" }, [
        _createElementVNode("h3", null, " Documents ")
      ], -1 /* CACHED */)),
      _withDirectives((_openBlock(), _createBlock(_component_el_tag, {
        class: "document-list-header__tag",
        size: "small",
        type: _ctx.adminTakenPlayerCountTag.type,
        effect: _ctx.adminTakenPlayerCountTag.effect
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.adminTakenPlayerCountTag.text), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["type", "effect"])), [
        [_directive_loading, _ctx.isDocumentListLoading]
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: _ctx.isDocumentListLoading,
          onClick: _ctx.search
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Apply filters ", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled", "onClick"]),
        _createVNode(_component_el_button, {
          loading: _ctx.isDocumentListLoading,
          circle: "",
          icon: _ctx.icons.Refresh,
          size: _ctx.ComponentSize.SMALL,
          onClick: _ctx.search
        }, null, 8 /* PROPS */, ["loading", "icon", "size", "onClick"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}